import Phase10OrderPage from './Phase10OrderPage';

export default function CareOrderPage() {
  return <Phase10OrderPage skuCode="care-pro" />;
}
